import React from "react";
import { Col, Row } from "react-bootstrap";
import "./styles.scss";

interface IProps {
  flag: string;
  name: string;
}

const CountryWithFlag = (props: IProps) => {
  return (
    <div>
      <div>
        <Row>
          <Col xs={12} xl={4} lg={5} className="pl-5 mt-3">
            <div className="country-image-wrapper">
              <img src={props.flag} alt="" />
            </div>
          </Col>
          <Col style={{ marginTop: "27px" }} xs={12} xl={8} lg={7}>
            <p style={{ color: "grey", fontWeight: "bold" }}>{props.name}</p>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CountryWithFlag;
